import { createSlice } from '@reduxjs/toolkit';

export interface DrawerState {
  bannerHeight: number | null;
  navigationHeight: number;
  headerHeight: number;
  modeToastHeight: number;
}

const initialState: DrawerState = {
  bannerHeight: null,
  navigationHeight: 0,
  headerHeight: 0,
  modeToastHeight: 0,
};

export const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    setBannerHeight: (state, action) => {
      state.bannerHeight = action.payload;
    },
    setNavigationHeight: (state, action) => {
      state.navigationHeight = action.payload;
    },
    setHeaderHeight: (state, action) => {
      state.headerHeight = action.payload;
    },
    setModeToastHeight: (state, action) => {
      state.modeToastHeight = action.payload;
    },
  },
});

export const {
  reducer: drawerReducer,
  actions: {
    setBannerHeight,
    setNavigationHeight,
    setHeaderHeight,
    setModeToastHeight,
  },
} = drawerSlice;
